import {create} from 'zustand';
import {RatingModalStore} from './types';

export const useRatingModalStore = create<RatingModalStore>(set => ({
	ratingModal: 'evaluate',
	setRatingModal: modal => set({ratingModal: modal}),
}));
